import React from 'react'
import Navbar from '../../components/user/Navbar'
import BreadCrumbComponent from '../../components/user/BreadCrumbComponent'
import FranchiseComponent from '../../components/user/FranchiseComponent'
import LocationComponent from '../../components/user/LocationComponent'
import FooterComponent from '../../components/user/FooterComponent'
import { Helmet } from "react-helmet";


const FranchisePage = () => {
  return (
    <div>

      
<Helmet>
        <title>Glazma - Franchise : Men's Grooming And Waxing Service.
        </title>
        <meta
          name="description"
          content="
          Men's Grooming and Waxing Service at Home in Noida, Delhi NCR. Get best men's grooming and waxing service by professional groomers.
         "
        />
      </Helmet>

      <div className="home-col-nav">
      <Navbar />
      </div>
        
        
        <BreadCrumbComponent name="Franchise" />
        <FranchiseComponent/>
        <LocationComponent/>
        <FooterComponent/>
    </div>
  )
}

export default FranchisePage